export {GamecodeModule} from './core/gamecode.module';
export {GamecodeService} from './core/gamecode.service';
export {ServicesInstantiatorService as GamecodeServicesInstantiatorService} from './core/services/services-instantiator.service';